import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */
// @ts-nocheck
import { EventEmitter } from 'events';

var EventTarget = /*#__PURE__*/function () {
  function EventTarget() {
    _classCallCheck(this, EventTarget);

    this._eventEmitter = new EventEmitter();
  }

  _createClass(EventTarget, [{
    key: "addEventListener",
    value: function addEventListener(name, handler) {
      return this._eventEmitter.addListener(name, handler);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(name) {
      var _this$_eventEmitter;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_this$_eventEmitter = this._eventEmitter).emit.apply(_this$_eventEmitter, [name].concat(args));
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(name, handler) {
      return this._eventEmitter.removeListener(name, handler);
    }
  }]);

  return EventTarget;
}();

export { EventTarget as default };